/**
 * Fetch wrapper for POS backend API calls.
 * Prepends VITE_BACKEND_URL and includes credentials so the server-issued
 * session cookie is sent with every request. Authentication and the caller's
 * identity MUST be derived from that cookie server-side — never from
 * client-supplied headers or a bundled API key.
 *
 * On any 401 response a `pos-session-expired` event is dispatched so the
 * PosAuthProvider can drop local user state and the admin layout can bounce
 * to /admin/login. This keeps the fetch util decoupled from routing.
 */

export const POS_SESSION_EXPIRED_EVENT = "pos-session-expired";

export async function posApiFetch(
  path: string,
  options: RequestInit = {}
): Promise<Response> {
  const baseUrl = (import.meta.env.VITE_BACKEND_URL || "").replace(
    /\/$/,
    ""
  );

  const isFormData = options.body instanceof FormData;

  const headers: HeadersInit = {
    // Let the browser set Content-Type (with boundary) for FormData
    ...(!isFormData && { "Content-Type": "application/json" }),
    ...(options.headers || {}),
  };

  const response = await fetch(`${baseUrl}${path}`, {
    credentials: "include",
    ...options,
    headers,
  });

  if (response.status === 401 && typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(POS_SESSION_EXPIRED_EVENT));
  }

  return response;
}
